module.exports = __webpack_public_path__ + "img/bell.6eec23e9.svg";